import { global } from './global';

module.exports = {
    fulfilmentTimetable: {
        showTimesWhenAllowDecideLater: false,
        noAvailableTimesMessage:
        `You may be in an unserviced or remote area. Please contact our  <a href='${global.wowCustomerCareUrl}' onclick="utag.link({'event.Action':'click','event.Category':'Fulfilment Modal', 'event.Hash': Math.random(0, Number.MAX_VALUE).toString(36), 'event.Label': 'Non serviced address error', 'event.Name': 'Hyperlink_click', 'site.Section': 'shop:discover'});">Customer Care Team</a> for options. Alternatively you could choose pick up.`,
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/fulfilment-timetable.js